import { action } from '@ember/object';
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';
export default class UnlinkedPostsRoute extends Route {
  model() {
    let { posts, page } = this.modelFor('page');
    return hash({ posts, page });
  }

  @action
  refreshModel() {
    this.refresh();
  }
}
